import { render, staticRenderFns } from "./CorrectionChanges.vue?vue&type=template&id=4a279470&scoped=true&"
import script from "./CorrectionChanges.vue?vue&type=script&lang=js&"
export * from "./CorrectionChanges.vue?vue&type=script&lang=js&"
import style0 from "./CorrectionChanges.vue?vue&type=style&index=0&id=4a279470&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a279470",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VAlert,VSimpleTable})
